import React from "react";
import { i18nMark } from "@lingui/react";
import PropTypes from "prop-types";

import { AccountStatusUi } from "../../login/common/account.status.ui";
import { ACCOUNT_STATUS } from "../../common/helpers/constants";

import NotFoundIcon from "../../common/img/not-available.svg";
import LockCycleIcon from "../../common/img/lockUserCycle.svg";

export function NotAvailable({ title, description, status }) {
  let _type =
    status === 403 ? ACCOUNT_STATUS.NOT_AVAILABLE : ACCOUNT_STATUS.WARNING;
  let _icon = status === 403 ? NotFoundIcon : LockCycleIcon;
  return (
    <AccountStatusUi
      status={{
        title: title,
        description: description,
        icon: _icon,
        type: _type
      }}
    />
  );
}
NotAvailable.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  status: PropTypes.number
};
NotAvailable.defaultProps = {
  title: i18nMark("Something went wrong"),
  description: i18nMark(
    "We're sorry, but we aren't sure what happened. You can try again or exit from this screen."
  )
};
